<template>
  <a-layout id="components-layout-demo-side" style="min-height: 100vh;">
    <a-layout-sider v-model="collapsed" style="position: relative;width: 100%" >
      <div class="logo" :class="collapsed ? 'siderActive':''"   >
        <img src="../assets/logo.png" alt="" >
        <span v-show="!collapsed" class="logoName">{{indexName}}</span>
      </div>
        <div class="menu-warp">
            <a-menu  style="position: relative;" :defaultSelectedKeys="[this.leftMenu[0].key]"  :selectedKeys="this.leftKey" mode="inline" theme="dark" @click="selectMenu">
                <a-menu-item class="subMenuTitle" :title="leftMenuTitle">
                    <span class="iconfont">&#xe7dd;</span>
                    <span v-show="!collapsed" >{{leftMenuTitle}}</span>
                </a-menu-item>
                <template v-for="item in leftMenu">
                    <a-menu-item v-if="!item.children" :key="item.key" :title="item.name">
                        <span class="iconfont">&#xe7dd;</span>
                        <span v-show="!collapsed">{{item.name}}</span>
                    </a-menu-item>
                    <sub-menu v-else :menu-info="item" :coll-info="collapsed" :key="item.key" />
                </template>
            </a-menu>
            <div style="left: 0;bottom: 0;height: 50px;width: 100%;line-height: 50px;text-align: left;position: absolute">
                <div @click="toggleCollapsed" style="display:inline-block;margin-left:19px;width: 28px;height: 28px;border-radius: 50%;background: #282a33;line-height: 28px;text-align: center;cursor: pointer" >
                    <!--          <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" />-->
                    <img v-if="!collapsed" src="../assets/iocn/outdent.svg" alt="" style="width: 15px;height: 15px;">
                    <img v-else src="../assets/iocn/indent.svg" alt="" style="width: 15px;height: 15px;">
                </div>
            </div>
        </div>
        <div style="border-top: 1px solid rgb(10, 11, 14);position: fixed;bottom: 50px;width: 10.4%;height: 2px;"></div>
    </a-layout-sider>
    <a-layout>
        <top-Header :widthNumber="widthNum"></top-Header>
        <a-layout-content style="padding-top: 60px;position: relative">
          <div id="navEdit">
            <a-tabs v-model="activeKey" hideAdd  type="editable-card" @edit="onEdit" @change="tabsData">
              <template v-for="pane in panes">
              <a-tab-pane v-if="pane || pane.length<0" :tab="pane.title" :key="pane.key" :closable="pane.closable"></a-tab-pane>
              </template>
            </a-tabs>
          </div>
            <!--此处判断的key值是首页统计数据的key值，与路由key值或id值相同，目的是背景色不一样-->
            <div :class="this.activeKey==1?'otherBack':'mainBack'">
                <keep-alive><router-view></router-view></keep-alive>
            </div>
        </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
  import topHeader from '../components/indexComponents/topHeader'
  import { Menu } from 'ant-design-vue';
  const SubMenu = {
    template: `
      <a-sub-menu :key="menuInfo.key" v-bind="$props" v-on="$listeners" style="text-align: left;" >
        <span slot="title" style="font-size: 1rem;">
          <span class="iconfont">&#xe7dd;</span><span v-show="!collInfo">{{ menuInfo.name }}</span>
        </span>
        <template v-for="item in menuInfo.children">
          <a-menu-item v-if="!item.children" :key="item.key" style="background-color:#1d1f2d;text-align: left;border-bottom:1px dashed #353749">
            <span style="font-size: 1rem;">{{ item.name }}</span>
          </a-menu-item>
          <sub-menu v-else :key="item.key" :menu-info="item" />
        </template>
      </a-sub-menu>
    `,
    name: 'SubMenu',
    // must add isSubMenu: true
    isSubMenu: true,
    props: {
      ...Menu.SubMenu.props,
      // Cannot overlap with properties within Menu.SubMenu.props
      menuInfo: {
        type: Object,
        default: () => ({}),
      },
      collInfo:undefined
    },
    methods: {
      clickMenu(item,key){

      }
    }
  };  //menu有二级菜单或三级菜单时遍历
  export default {
    components: {
      'sub-menu': SubMenu,//左侧二级菜单
      topHeader //头部
    },
    data() {

      const panes = [
        { title: '首页', content: 'Content of Tab 1', key: '1' },
      ];
      return {
          widthNum:undefined,
        collapsed: false,
        indexName:'安全管理平台',
        leftMenuTitle:'告警管理',
        //左侧菜单数据
        leftMenu:[
          {name:'首页',key:'1',url:'index',icon:'../assets/iocn/qrcode.svg'},
          {name:'标准表格',key:'2',url:'list',icon:'../assets/iocn/qrcode.svg'},
          {name:'树形表格',key:'3',url:'treeTable',icon:'../assets/iocn/qrcode.svg'},
          {name:'标准详情',key:'4',url:'standardDetail',icon:'../assets/iocn/qrcode.svg'},
          // {name:'可配置详情',key:'5',url:'configDetail',icon:'../assets/iocn/qrcode.svg'},
          {name:'通联详情',key:'6',url:'communications',icon:'../assets/iocn/qrcode.svg'},
          {name:'设备状态',key:'8',url:'equipmentDetail',icon:'../assets/iocn/qrcode.svg'},
          {name:'弹出框',key:'9',url:'popup',icon:'../assets/iocn/qrcode.svg'},
          {name:'新增详情',key:'10',url:'addDetail',icon:'../assets/iocn/qrcode.svg'},
          {name:'系统管理',key:'7',icon:'../assets/iocn/qrcode.svg',children:[
              {name:'人员信息',key:'7-1',url:'userPage',icon:'../assets/iocn/qrcode.svg'},
          ]},
        ],
        leftKey:[],
        //标签页
        activeKey: panes[0].key,  //激活tabs的Key值
        panes,
        arr:[],
        newTabIndex: 0,
      };
    },
    methods: {
      callback(key) {
        console.log(key);
      },
      onEdit(targetKey, action) {
        this[action](targetKey);
      },
        //tabs标签删除
      remove(targetKey) {
        let activeKey = this.activeKey;
        let lastIndex;
        this.panes.forEach((pane, i) => {
          if (pane.key === targetKey) {
            lastIndex = i - 1;
          }
        });
        const panes = this.panes.filter(pane => pane.key !== targetKey);
        if (panes.length && activeKey === targetKey) {
          if (lastIndex >= 0) {
            activeKey = panes[lastIndex].key;
          } else {
            activeKey = panes[0].key;
          }
        }
          this.panes = panes;
          this.activeKey = activeKey;
          this.leftKey=[activeKey]
          let menu=this.recursion(this.leftMenu,activeKey)
          this.$router.push({path:menu.url,query:""});  //点击关闭当前tabs,跳转到上一个tabs
      },
      //点击menu跳转，并且添加tabs
      selectMenu(key){
          var obj=this.recursion(this.leftMenu,key.key)
            this.panes.push({title:obj.name, key:obj.key,});
            this.panes=this.unique(this.panes);
            this.activeKey=key.key
            this.leftKey=[key.key]
            this.$router.push({path:obj.url,query:""});
      },
      //递归查找根据key找到相对应的的menu信息
      recursion(data,id) {
        let result;
        if (!data) {
          return;
        }
        for (var i = 0; i < data.length; i++) {
          let item = data[i];
          if (item.key === id) {
            result = item;
            break;
          } else if (item.children && item.children.length > 0) {
            result = this.recursion(item.children, id);
            if(result) return result // 关键代码：如果找到，就直接返回，结束后面的循环
          }
        }
        return result;
      },
      //去重tabs标签数据
      unique(arr) {
        let newArr = [];
        let obj = {};
        for (var i = 0; i < arr.length; i++) {
          if (!obj[arr[i].key]) {
            newArr.push(arr[i]);
            obj[arr[i].key] = true;
          }
        }
        console.log(newArr)
       return newArr
      },
      //标签点击切换router-view
      tabsData(){
        var obj=this.recursion(this.leftMenu,this.activeKey)
        this.$router.push({path:obj.url,query:""});
      },
      toggleCollapsed() {

          if(!this.collapsed){
                this.widthNum=80
          }else{
              this.widthNum=200
          }
        this.collapsed = !this.collapsed;

      },
    },
    created(){
      this.leftKey= [this.leftMenu[0].key]
    },
      mounted() {
        this.$router.push({path:this.leftMenu[0].url,query:""});    //默认跳转到第一个菜单项页面
    }
  };
</script>

<style scoped>
    .mainBack{
        background: #e9ecf0;
        padding: 20px 22px;
    }
    .otherBack{
        background: #e9ecf0;
        padding: 20px 22px;
    }
    #components-layout-demo-side .logo {
        height: 60px;
        background-color: #252d3d;
        line-height: 60px;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        position: fixed;
        z-index: 1;
        width: 200px;
    }
    .siderActive{
      padding-left: 16px;
    }
    .logo img{
      margin-left: 9px;
      margin-right: 6px;
      width: 22px;
      vertical-align: middle;
      margin-top: -6px;
    }
    #components-layout-demo-side .logo .logoName{
      font-size: 18px;
      color: #ffffff;
    }
    .ant-layout-sider {
      background: #212333;
    }
    .ant-layout-sider-trigger{
      background: #212333 !important;
    }
    .ant-menu-dark .ant-menu-inline.ant-menu-sub{
      background-color: #11121a !important;
    }
    .ant-menu-dark, .ant-menu-dark .ant-menu-sub{
      background: #212333 !important;
    }
    .menuTitle{
        font-size: 16px;
        letter-spacing: 1px;
        color: #ffffff;
        text-align: left;
        padding-left: 22px;
        height: 54px;
        line-height: 54px;
        border-bottom: 1px solid  #3b3d4c;
        margin-bottom: 0;
    }
    .ant-menu.ant-menu-dark .ant-menu-item-selected, .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
        background-color: #1d1f2d;
    }
    .ant-menu.ant-menu-dark .ant-menu-item-selected .iconfont, .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected .iconfont{
        color: #3a99fb;
    }
    #navEdit .ant-tabs-nav-scroll{
        padding-left: 24px;
    }
    #navEdit{
       height: 48px;
       background: #fff;
    }
    .menu-warp{
      height: calc(100% - 60px);
      position: fixed;
      width: 200px;
      top: 60px;
    }
    .menu-warp .ant-menu-item{
      /* padding-left: 24px; */
      display: inline-block;
      text-align: left;
      padding-top: 12px!important;
      padding-bottom: 12px!important;
      width: 100%;
    }
    .menu-warp .ant-menu-item img{
      width: 14px;
      margin-right: 8px;
    }
    .menu-warp .ant-menu-item span{
      font-size: 1rem;
      vertical-align: middle;
    }
    .ant-menu-dark.ant-menu-inline .subMenuTitle{
      border-bottom: 1px solid #3b3d4c;
      height: 43px;
    }
    .ant-layout-sider-collapsed .ant-menu-item,.ant-layout-sider-collapsed .ant-menu-submenu-title{
      padding-left: 30px;
    }
    .ant-layout-sider-collapsed .subMenuTitle{
      text-align: center;
      /* padding: 13px 0 14px!important; */
      border-bottom: 1px solid #3b3d4c;
    }
    .ant-layout-sider-collapsed .ant-menu-submenu{
      padding-top: 12px!important;
      padding-bottom: 12px!important;
    }
</style>